import { DBDef_AdvisorWizard } from '@app/advisor-content-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_AdvisorWizard } from '../../_entity/wizard/ModuleFE_AdvisorWizard.js';
import { ModuleFE_AdvisorSnippet } from '../../_entity/snippet/ModuleFE_AdvisorSnippet.js';
import { Manager_AdvisorWizard } from '../../ui/_managers/Manager_AdvisorWizard/Manager_AdvisorWizard.js';
import { ModuleFE_Tag, ModuleFE_Variable } from '@app/hcs-frontend';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_AdvisorWizard,
    dbDef: DBDef_AdvisorWizard,
    tag: ['Aw', 'Advisor Wizard'],
    modulesToAwait: [ModuleFE_AdvisorWizard, ModuleFE_AdvisorSnippet, ModuleFE_Variable, ModuleFE_Tag],
    ManagerComponent: Manager_AdvisorWizard,
    searchTermsExtractor: (item) => {
        const stepLabels = item.steps?.map((step) => step.label.toLowerCase()) ?? [];
        return [item.label.toLowerCase(), item._id, ...stepLabels];
    },
});
export const WorkHubItem_AdvisorWizard = WorkHubItem;
export const UtilObject_AdvisorWizard = UtilObject;
export const SearchItem_AdvisorWizard = SearchItem;
//# sourceMappingURL=advisor-wizard.js.map